import { render, staticRenderFns } from "./BasicHtml.vue?vue&type=template&id=1b6be0fc&"
import script from "./BasicHtml.vue?vue&type=script&lang=js&"
export * from "./BasicHtml.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports